// extracted by mini-css-extract-plugin
export default {"productGallery":"FN-z","inQuickShop":"GN-z"};